import { formatPercentage } from "@ui-seeker/utils/"

import { adminScrapingDataReviewPercentageData } from "../../../@signals"


export default function legacyColumn() {
	return {
		name: "legacy",
		label: `Legacy (${formatPercentage(adminScrapingDataReviewPercentageData.value["percentageLegacy"], { decimals: 2 })})`,
		options: {
			display: false,
			filter: false,
			setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    minWidth: 80,
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			customBodyRowRender: value => value ? "V1" : "V2"
		}
	}
}